import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import {DialogProps} from 'packages/common-types/base-types';
import {useState} from 'react';
import useAppSelector from 'packages/hooks/use-app-selector';
import {
  selectGeneratedRound,
  setGeneratedRound,
} from 'redux/features/round-slice';
import {selectTournament} from 'redux/features/app-slice';
import useAppDispatch from 'packages/hooks/use-app-dispatch';
import Select from 'react-select';
import _ from 'lodash';

const ChangeMatch = (props: DialogProps) => {
  const {modalOpen, toggle} = props;
  const dispatch = useAppDispatch();
  const generatedRound = useAppSelector(selectGeneratedRound);
  const tournament = useAppSelector(selectTournament);
  const [competitorA, setCompetitorA] = useState();
  const [competitorB, setCompetitorB] = useState();
  const [optionsChange, setOptionsChange] = useState([]);
  let options: {label: string; value: number}[] = [];
  if (tournament.conditions.modalityGame === 'Individual') {
    options = tournament.inscriptions.map(({user}, index) => {
      return {
        label: user.fullName,
        value: index,
      };
    });
  } else if (generatedRound) {
    const {tables} = generatedRound;
    tables.forEach(({competitorOne, competitorTwo}, index) => {
      options.push({
        label: `${competitorOne[0].members[0].fullName},${competitorOne[0].members[1].fullName}`,
        value: index,
      });
      options.push({
        label: `${competitorTwo[0].members[0].fullName},${competitorTwo[0].members[1].fullName}`,
        value: index,
      });
    });
  }

  const findPositons = (competitorA: string, competitorB: string) => {
    let tableNumberA = {
      index: -1,
      competitor: '',
      competitorIndex: -1,
    };
    let tableNumberB = {
      index: -1,
      competitor: '',
      competitorIndex: -1,
    };
    const {tables} = generatedRound;
    tables.forEach((table, index) => {
      const {competitorOne, competitorTwo} = table;
      competitorOne.forEach(({members}, competitorIndex) => {
        members.forEach(({fullName}) => {
          if (fullName === competitorA) {
            tableNumberA = {
              index,
              competitor: 'One',
              competitorIndex,
            };
          }
          if (fullName === competitorB) {
            tableNumberB = {
              index,
              competitor: 'One',
              competitorIndex,
            };
          }
        });
      });
      competitorTwo.forEach(({members}, competitorIndex) => {
        members.forEach(({fullName}) => {
          if (fullName === competitorA) {
            tableNumberA = {
              index,
              competitor: 'Two',
              competitorIndex,
            };
          }
          if (fullName === competitorB) {
            tableNumberB = {
              index,
              competitor: 'Two',
              competitorIndex,
            };
          }
        });
      });
    });
    return [tableNumberA, tableNumberB];
  };

  const handleSaveOrEdit = async () => {
    const {index, tables} = generatedRound;
    const tablesCopy = _.cloneDeep(tables);
    const [tableNumberA, tableNumberB] = findPositons(competitorA, competitorB);
    const {competitorOne: competitorOneA, competitorTwo: competitorOneB} =
      tablesCopy[tableNumberA.index];
    const {competitorOne: competitorTwoA, competitorTwo: competitorTwoB} =
      tablesCopy[tableNumberB.index];
    let aux;
    if (tableNumberA.competitor === 'One') {
      aux = _.cloneDeep(competitorOneA[tableNumberA.competitorIndex]);
      if (tableNumberB.competitor === 'One') {
        competitorOneA[tableNumberA.competitorIndex] =
          competitorTwoA[tableNumberB.competitorIndex];
      } else {
        competitorOneA[tableNumberA.competitorIndex] =
          competitorTwoB[tableNumberB.competitorIndex];
      }
    } else {
      aux = _.cloneDeep(competitorOneB[tableNumberA.competitorIndex]);
      if (tableNumberB.competitor === 'One') {
        competitorOneB[tableNumberA.competitorIndex] =
          competitorTwoA[tableNumberB.competitorIndex];
      } else {
        competitorOneB[tableNumberA.competitorIndex] =
          competitorTwoB[tableNumberB.competitorIndex];
      }
    }
    if (tableNumberB.competitor === 'One') {
      competitorTwoA[tableNumberB.competitorIndex] = aux;
    } else {
      competitorTwoB[tableNumberB.competitorIndex] = aux;
    }
    dispatch(setGeneratedRound({index, tables: tablesCopy}));
    toggle();
  };

  const selectStyles = {
    menu: (provided: any) => ({
      ...provided,
      zIndex: 2000,
    }),
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={modalOpen}
      onClose={toggle}
      aria-labelledby="simple-dialog"
    >
      <DialogTitle id="simple-dialog">Cambiar parejas</DialogTitle>
      <DialogContent style={{minHeight: 500}}>
        <div style={{paddingBottom: 20}}>
          <Select
            options={options}
            onChange={(value: any) => {
              setOptionsChange(
                options.filter(({label}) => label !== value.label)
              );
              if (tournament.conditions.modalityGame === 'Individual') {
                setCompetitorA(value.label);
              } else {
                setCompetitorA(value.label.split(',')[0]);
              }
            }}
          />
        </div>
        <div style={{paddingBottom: 30}}>
          {optionsChange.length !== 0 && (
            <Select
              styles={selectStyles}
              options={optionsChange}
              onChange={(value: any) => {
                if (tournament.conditions.modalityGame === 'Individual') {
                  setCompetitorB(value.label);
                } else {
                  setCompetitorB(value.label.split(',')[0]);
                }
              }}
            />
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={toggle} color="default">
          Cancelar
        </Button>
        <Button onClick={handleSaveOrEdit} color="primary">
          Cambiar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangeMatch;
